<div
  class="bg-primary-on box-border flex w-full text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
  }">
  @let hasError = ngControl.errors && ngControl.touched;
  <div
    class="bg-input-accessibility border-input-accessibility border-input text-input-accessibility-text peer p-input relative flex w-16 items-center rounded-l-lg placeholder-transparent">
    <span class="material-symbols-rounded absolute"> accessibility_new </span>
  </div>
  <div class="relative w-full bg-inherit">
    <input
      [attr.data-testid]="id() | appendTestId: 'input'"
      [formControl]="activeTextValue"
      [id]="id()"
      [ngClass]="{
        'border-input-error! focus:border-input-focus': hasError,
        'border-input-ring focus:border-input-focus': !hasError,
      }"
      [placeholder]="label() ?? ''"
      class="border-input-ring border-input peer p-input w-full rounded-r-lg bg-transparent placeholder-transparent focus:ring-0"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      [for]="id()"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-label pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm peer-focus:ring-0">
      {{ formattedLabel() }}
    </label>
    @if (hasError && !errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-content></ng-content>
      </aw-error-message>
    }
    @if (hasError && errorTemplate()) {
      <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
        <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
      </aw-error-message>
    }
  </div>
</div>
